import { FontVariant } from "react-native";
import Metrics from "./Metrics";

const fontRegular = "Aeonik";
const fontMedium = "Aeonik-Medium";
const fontBold = "Aeonik-Bold";

const Typography = {
  headline0: {
    fontFamily: fontRegular,
    fontSize: Metrics.fontSize18,
    lineHeight: 18,
    fontWeight: "400" as "400",
    fontStyle: "normal" as "normal",
    fontVariant: ["tabular-nums"] as FontVariant[],
  },
  headline1: {
    fontFamily: fontRegular,
    fontSize: Metrics.fontSize18,
    lineHeight: 14,
    fontWeight: "500" as "500",
    fontStyle: "normal" as "normal",
    fontVariant: ["tabular-nums"] as FontVariant[],
  },
  headline2: {
    fontFamily: fontRegular,
    fontSize: Metrics.fontSize14,
    lineHeight: 11,
    fontWeight: "500" as "500",
    fontStyle: "normal" as "normal",
    fontVariant: ["tabular-nums"] as FontVariant[],
  },
  headline3: {
    fontFamily: fontRegular,
    fontSize: Metrics.fontSize20,
    lineHeight: 11,
    fontWeight: "500" as "500",
    fontStyle: "normal" as "normal",
    fontVariant: ["tabular-nums"] as FontVariant[],
  },
  body1: {
    fontFamily: fontRegular,
    fontSize: Metrics.fontSize14,
    lineHeight: 12,
    fontWeight: "400" as "400",
    fontStyle: "normal" as "normal",
    fontVariant: ["tabular-nums"] as FontVariant[],
  },
  body1Medium: {
    fontFamily: fontMedium,
    fontSize: Metrics.fontSize12,
    lineHeight: 12,
    fontWeight: "400" as "400",
    fontStyle: "normal" as "normal",
    fontVariant: ["tabular-nums"] as FontVariant[],
  },
  bodyNumber: {
    fontFamily: fontMedium,
    fontSize: Metrics.fontSize12,
    lineHeight: 14,
    fontWeight: "400" as "400",
    fontStyle: "normal" as "normal",
    fontVariant: ["tabular-nums"] as FontVariant[],
  },
  titleTooltip: {
    fontFamily: fontMedium,
    fontSize: Metrics.fontSize12,
    lineHeight: 14.4,
    fontWeight: "400" as "400",
    fontStyle: "normal" as "normal",
    fontVariant: ["tabular-nums"] as FontVariant[],
  },
  bodyTooltip: {
    fontFamily: fontRegular,
    fontSize: Metrics.fontSize12,
    lineHeight: 14,
    fontWeight: "400" as "400",
    fontStyle: "normal" as "normal",
    fontVariant: ["tabular-nums"] as FontVariant[],
  },
  editNumber: {
    fontFamily: fontRegular,
    fontSize: Metrics.fontSize12,
    lineHeight: 9,
    fontWeight: "400" as "400",
    fontStyle: "normal" as "normal",
    fontVariant: ["tabular-nums"] as FontVariant[],
  },
  title: {
    fontFamily: fontBold,
    fontSize: Metrics.fontSize12,
    lineHeight: 24,
    fontWeight: "700" as "700",
    fontStyle: "normal" as "normal",
    fontVariant: ["tabular-nums"] as FontVariant[],
  },
  modalTitle: {
    fontFamily: fontMedium,
    fontSize: Metrics.fontSize12,
    lineHeight: 9,
    fontWeight: "400" as "400",
    fontStyle: "normal" as "normal",
    fontVariant: ["tabular-nums"] as FontVariant[],
  },
  bodyTitle: {
    fontFamily: fontRegular,
    fontSize: Metrics.fontSize12,
    lineHeight: 16,
    fontWeight: "400" as "400",
    fontStyle: "normal" as "normal",
    fontVariant: ["tabular-nums"] as FontVariant[],
  },
  bodyBold: {
    fontFamily: fontBold,
    fontSize: Metrics.fontSize10,
    lineHeight: 10,
    fontWeight: "700" as "700",
    fontStyle: "normal" as "normal",
    fontVariant: ["tabular-nums"] as FontVariant[],
  },
  bodySubtitle: {
    fontFamily: fontRegular,
    fontSize: Metrics.fontSize10,
    lineHeight: 11,
    fontWeight: "400" as "400",
    fontStyle: "normal" as "normal",
    fontVariant: ["tabular-nums"] as FontVariant[],
  },
  small: {
    fontFamily: fontRegular,
    fontSize: Metrics.fontSize10,
    fontWeight: "400" as "400",
    fontStyle: "normal" as "normal",
    fontVariant: ["tabular-nums"] as FontVariant[],
  },
  smaller: {
    fontFamily: fontRegular,
    fontSize: Metrics.fontSize10,
    fontWeight: "400" as "400",
    fontStyle: "normal" as "normal",
    fontVariant: ["tabular-nums"] as FontVariant[],
  },
  tag: {
    fontFamily: fontRegular,
    fontSize: Metrics.fontSize8,
    lineHeight: 9,
    fontWeight: "400" as "400",
    fontStyle: "normal" as "normal",
    fontVariant: ["tabular-nums"] as FontVariant[],
  },
  button: {
    fontFamily: fontMedium,
    fontSize: Metrics.fontSize10,
    lineHeight: 8,
    fontWeight: "400" as "400",
    fontStyle: "normal" as "normal",
    fontVariant: ["tabular-nums"] as FontVariant[],
  },
  select: {
    fontFamily: fontMedium,
    fontSize: Metrics.fontSize10,
    lineHeight: 10,
    fontWeight: "400" as "400",
    fontStyle: "normal" as "normal",
    fontVariant: ["tabular-nums"] as FontVariant[],
  },
};

export default Typography;
